import { Pagination as _FusePagination } from '@tvg/fuse-design/pagination';
import { PLPQueryData, usePLPQuery } from 'client/api/plp-results';
import { EUserAction } from 'client/config';
import withPrefetch from 'client/hoc/withPrefetch';
import { usePLPNavigate } from 'client/hooks/usePLPNavigate';
import React, { useCallback, useMemo } from 'react';
import { useSEOBaseURL } from './useSEOBaseURL';

const FusePagination = withPrefetch(_FusePagination, (e) => (e.target as HTMLAnchorElement | undefined)?.href);

function Pagination() {
  const { data } = usePLPQuery(
    useCallback(
      (d: PLPQueryData) => ({
        numResults: d.numResults,
        resultsPerPage: d.resultsPerPage,
        page: d.page,
      }),
      [],
    ),
  );
  const plpNavigate = usePLPNavigate();

  const numberOfPages = useMemo(() => data && Math.ceil(data.numResults / data.resultsPerPage), [data]);
  const seoURL = useSEOBaseURL();

  const paginationCallback = useCallback(
    (_event: React.MouseEvent<HTMLInputElement>, currentPageNumber: number) => {
      // Ensure we are repositioned at the top of the page
      document?.getElementById('product-listing-root')?.scrollIntoView();
      document?.getElementById('results-header')?.focus();
      plpNavigate({ pageNumber: currentPageNumber }, EUserAction.PAGINATION);
    },
    [plpNavigate],
  );

  return (
    <FusePagination
      currentPage={data?.page || 1}
      numberOfPages={numberOfPages}
      callback={paginationCallback}
      dataTestId="pagination"
      seoUrl={seoURL}
    />
  );
}

export default React.memo(Pagination);
